<template>
  <td class="ui" :class="[ { 'dimmable': screenWidth > 768, 'dimmed': hovered } ]" @mouseover="hovered = true" @mouseleave="hovered = false" @click="select">
    <div class="ui simple responsive dimmer" :class="{ 'red': expired || disabled }">
      <div class="content">
        <div class="center" v-if="disabled">
          Not Available
        </div>
        <div class="center" v-else-if="expired">
          Too Late
        </div>
        <div class="center" v-else>
          <p><strong>{{ boat.name }}</strong></p>
          <p v-if="!boat.startsAtHalfHour">{{ hour }} Uhr</p>
          <p v-else>
            {{ (parseInt(hour.split(' - ')[0]) - 1) + ':30' }} - {{ (parseInt(hour.split(' - ')[1]) - 1) + ':30' }}
          </p>
        </div>
      </div>
    </div>
    <div :class="[ booking.status, { 'expired': expired }, { 'disabled': disabled }, { 'my': booking.clientId === this.clientId } ]"
         class="booking-field">
    </div>
  </td>
</template>

<script type="text/ecmascript-6">
  import * as services from './../services'

  const defaultBooking = {
    _id: null,
    _boat: null,
    hour: null,
    date: null,
    status: 'open',
    clientId: null
  }

  export default {
    data() {
      return {
        hovered: false,
        screenWidth: null,
        booking: {
            _id: null,
            _boat: this.boat._id,
            hour: this.hour,
            date: this.date,
            status: 'open',
            clientId: this.clientId
        }
      }
    },
    watch: {
      allBookings: function () {
        this.booking = {
          ...this.booking,
          _id: null,
          date: this.date,
          status: 'open',
          clientId: null
        }

        let thisBooking = this.allBookings.find(booking => {
          return booking.hour === this.hour && booking._boat === this.boat._id && booking.date === this.date
        })

        if (thisBooking) this.booking = thisBooking
      },
      date: function (date) {
//        console.log('date changed')
//        this.booking = {
//          ...this.booking,
//          _id: null,
//          date: this.date,
//          status: 'open',
//          clientId: null
//        }
//
//        console.log(date)

//        services.bookingService.find({query: {_boat: this.boat._id, hour: this.hour, date: this.date, $limit: 1}}).then(bookings => {
//          if (bookings.data[0] && bookings.data[0].date === this.date) this.booking = bookings.data[0]
//        })
      },
      updatedBooking: {
        deep: true,
        handler: function (newBooking) {
          if (newBooking) {
            if (newBooking._boat === this.boat._id && newBooking.hour === this.hour && newBooking.date === this.date) {
              this.booking = newBooking
            }
          }
        }
      },
    },
    computed: {
      booked() {
        return this.booking.status == 'reserved'
      },
      disabled() {
        if (this.booking.status === 'open') return false

        if (['selected'].indexOf(this.booking.status) > -1 && this.booking.clientId === this.clientId) return false

        return true
      },
      expired() {
        return moment().isAfter(
          moment(this.date)
            .hour(this.hour.split(" - ")[0])
            .minute(0).second(0)
            .subtract(this.bookingAllowedBefore, 'seconds')
        )
      }
    },
    mounted() {
      services.bookingService.find({query: {_boat: this.boat._id, hour: this.hour, date: this.date, $limit: 1}}).then(bookings => {
        if (bookings.data[0]) {
          this.booking = bookings.data[0]

          if (this.booking.status == 'selected' && this.booking.clientId == this.clientId && this.selected.filter(b => {return b._id == this.booking._id}).length == 0) this.selected.push(this.booking)
        }
      })

      this.screenWidth = window.screen.width
      let that = this

      this.$nextTick(function() {
        window.addEventListener('resize', function(e) {
          that.screenWidth = window.screen.width
        });
      })
    },
    methods: {
      select() {
        if (this.disabled || this.expired) return

        let bookingDocument = {
          '_boat': this.boat._id,
          'boat': {
            'name': this.boat.name
          },
          'hour': this.hour,
          'date': this.date,
          'cost': this.boat.price,
          'status': this.booking.status === 'selected' ? 'open' : 'selected',
          'clientId': this.clientId
        }

        services.bookingService.find({ query: {
          '_boat': this.boat._id,
          'date': this.date,
          'hour': this.hour,
          $limit: 1
        }}).then((bookings) => {
          let bookingId = null

          if (bookings.data.length > 0) {
            bookingId = bookings.data[0]._id

            let oldBooking = bookings.data[0]

            if (oldBooking.clientId === this.clientId) {
              if (this.booking.status !== oldBooking.status) {
                this.booking.status = oldBooking.status
                bookingDocument.status = this.booking.status === 'selected' ? 'open' : 'selected'
              }
              // TODO: case when the current one is not open, or any other non-sync (should just deselect the slot)
            } else if (this.booking.status === 'open' && oldBooking.status === 'selected') {
              throw new Error('Booking already selected by someone else')
            }
          }

          if (bookingId) {
            services.bookingService.patch(bookingId, bookingDocument).then((booking) => {
              if (booking.status == 'selected') this.selected.push(booking)
              else {
//                console.log('indexOf', this.selected.findIndex(selected => {return selected._id === booking._id}))
                this.selected.splice(this.selected.findIndex(selected => {return selected._id === booking._id}), 1)
              }
            }).catch(reason => {
              toastr.error(reason)
            })
          } else {
            services.bookingService.create(bookingDocument).then((booking) => {
              if (booking.status == 'selected') this.selected.push(booking)
              else this.selected.splice(this.selected.findIndex(selected => {return selected._id === booking._id}), 1)
            }).catch(reason => {
              toastr.error(reason)
            })
          }
        }).catch(error => {
          toastr.error(error)

          throw error
        })
      },
    },
    props: ['boat', 'hour', 'date', 'bookingAllowedBefore', 'selected', 'clientId', 'updatedBooking', 'allBookings']
  }
</script>

<style scoped>
  td {
    padding: 0 !important;
    overflow: visible !important;
    cursor: pointer !important;
  }
  .booking-field {
    width: 100%;
    height: 70px;
  }
  .expired {
    background-color: #f1f1f1
  }
  .selected, .reserved, .disabled, .blocked {
    background-color: #c46c68;
  }
  .my.selected {
    background-color: #75a6cc;
  }
  .dimmed.dimmable>.ui.simple.dimmer {
    width: 102%;
    height: 102%;
    position: absolute;
    font-size: 11px;
    /*transform: translate(-8.333%, -8.333%);*/
    z-index: 1000;
    background-color: rgba(38, 59, 102, 0.8) !important;
    /*-webkit-border-radius: 5px;*/
    /*-moz-border-radius: 5px;*/
    /*border-radius: 5px;*/
  }
  .dimmed.dimmable>.ui.simple.dimmer.red {
    background-color: rgba(174, 24, 24, 0.8) !important;
  }
  .ui.dimmer {
    background-color: rgba(38, 59, 102, 0.6)
  }
  p {
    margin-bottom: 2px;
  }

  @media (max-width: 768px) {
    .ui.responsive.dimmer {
      display: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// BookingChoice.vue?38a7dccc